import { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { LoginCallback, LogoutCallback, useUser } from '@myosh/myosh-login';
import { PrivateRoute } from './components/PrivateRoute';
import LoginPage from './pages/LoginPage';
import Home from './pages/Home';
import EnergyCheck from './pages/EnergyCheck';

function App() {
  const { state } = useUser();
  const isAuthenticated = state.auth;

  useEffect(() => {
    if (!isAuthenticated) {
      localStorage.clear();
    }
  }, [isAuthenticated]);

  return (
    <Routes>
      <Route path="/auth/cb/logout" element={<LogoutCallback />} />
      <Route
        path="/auth/cb/silent"
        element={<div>Silent renewal callback</div>}
      />
      <Route path="/auth/cb" element={<LoginCallback />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<PrivateRoute />}>
        <Route index element={<Home />} />
        <Route path="energy-check" element={<EnergyCheck />} />
      </Route>
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default App;
